// @ts-check

import { MapView, Mappedin, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";
import PermissionManager from '../../../../../infrastructure/js/utils/permissionManager';
import { Logger } from "../Utils/logger";



/**
 * @param {any} props
 * @param {MapView | undefined} mapView
 * 
 */
export default function useFetchFullStatus(props, mapView) {

  let actions = props.actions;
  
  // let mapId = props.match.params.mapId;
  // console.log('mapId ===> ', mapId);
  
  
  /** 
   * @type {[number | null, Function]}
  */
  const [timerId, setTimerId] = useState(null);
  
  const startTimer = () => {
    // console.log('ZZZZZZZZZZZZZ START TIMER ===> ');
    if (!timerId) {
      
      
      let refreshRateSetting = PermissionManager.getOrgPreferences().refreshRate;
      console.log('------------ refreshRateSetting ===> ', refreshRateSetting);
      
      if (refreshRateSetting === 0) {
        return;
      }
      
      let INTERVAL_MSEC = refreshRateSetting * 1000;
      
      // console.log('ZZZZZZZZZZZZZ START TIMER DO !! ===> ');
      const intervalId = setInterval(() => {
        // console.log('xxxxxxxxxxxxxxxx TIMER !!!!!!!!!!!!!!!!!!!! ===> ');
        actions.fetchFullStatus();
      }, INTERVAL_MSEC);
      
      setTimerId(intervalId);
      
    }
  };
  
  const stopTimer = () => {
    if (timerId) {
      clearInterval(timerId);
      setTimerId(null);
    }
  };  
  
  

  useEffect(() => {
    console.log('FULLSTATUS LOAD ===> ');
    actions.fetchFullStatus();
    
    return () => {
      // Logger.doLog('----------- FULLSTATUS LOAD UNMOUNTED !!!!!!');
      stopTimer();
    };

  }, [mapView]);


  return [
    startTimer,
    stopTimer
  ];
}





